<template>
    <div class="form-container">
        <div class="form-title">考试报名表</div>
        <div class="form-content">
            <!-- Vue2 原生表单 -->
            <form @submit.prevent="submitForm">
                <!-- 姓名 -->
                <div class="form-item">
                    <label class="form-label">姓名</label>
                    <input type="text" class="form-input" placeholder="请输入姓名" v-model="formData.name"
                        @input="clearError('name')" />
                    <span class="error-message" v-if="errors.name">{{ errors.name }}</span>
                </div>

                <!-- 学历（原生下拉框） -->
                <div class="form-item">
                    <label class="form-label">学历</label>
                    <select class="form-select" v-model="formData.education" @change="clearError('education')">
                        <option value="">请选择学历</option>
                        <option v-for="item in educationOptions" :key="item.value" :value="item.value">
                            {{ item.text }}
                        </option>
                    </select>
                    <span class="error-message" v-if="errors.education">{{ errors.education }}</span>
                </div>

                <!-- 单位 -->
                <div class="form-item">
                    <label class="form-label">单位</label>
                    <input type="text" class="form-input" placeholder="请输入工作单位" v-model="formData.company"
                        @input="clearError('company')" />
                    <span class="error-message" v-if="errors.company">{{ errors.company }}</span>
                </div>

                <!-- 所在城市 -->
                <div class="form-item">
                    <label class="form-label">所在城市</label>
                    <input type="text" class="form-input" placeholder="请输入所在城市" v-model="formData.city"
                        @input="clearError('city')" />
                    <span class="error-message" v-if="errors.city">{{ errors.city }}</span>
                </div>

                <!-- 联系电话 
                <div class="form-item">
                    <label class="form-label">联系电话</label>
                    <input type="tel" class="form-input" placeholder="请输入联系电话" v-model="formData.phone"
                        @input="clearError('phone')" />
                    <span class="error-message" v-if="errors.phone">{{ errors.phone }}</span>
                </div>-->

                <!-- 报考科目（原生下拉框） -->
                <div class="form-item">
                    <label class="form-label">报考科目</label>
                    <select class="form-select" v-model="formData.subject" @change="clearError('subject')">
                        <option value="">请选择报考科目</option>
                        <option v-for="item in subjectOptions" :key="item.value" :value="item.value">
                            {{ item.text }}
                        </option>
                    </select>
                    <span class="error-message" v-if="errors.subject">{{ errors.subject }}</span>
                </div>

                <!-- 是否认证（原生单选框） -->
                <div class="form-item">
                    <label class="form-label">是否认证</label>
                    <div class="radio-group">
                        <label class="radio-label">
                            <input type="radio" name="isCertified" value="1" v-model="formData.isCertified" />
                            <span>是</span>
                        </label>
                        <label class="radio-label">
                            <input type="radio" name="isCertified" value="0" v-model="formData.isCertified" />
                            <span>否</span>
                        </label>
                    </div>
                </div>

                <!-- 是否签到（原生单选框） -->
                <div class="form-item">
                    <label class="form-label">是否签到</label>
                    <div class="radio-group">
                        <label class="radio-label">
                            <input type="radio" name="isSigned" value="1" v-model="formData.isSigned" />
                            <span>是</span>
                        </label>
                        <label class="radio-label">
                            <input type="radio" name="isSigned" value="0" v-model="formData.isSigned" />
                            <span>否</span>
                        </label>
                    </div>
                </div>

                <!-- 提交按钮 -->
                <button type="submit" class="submit-btn">提交</button>
            </form>
        </div>
    </div>
</template>

<script>
import { firstApi } from '@/http/api';
export default {
    name: 'ExamRegistrationForm',
    data() {
        return {
            formData: {
                name: '',
                education: '',
                company: '',
                city: '',
                phone: '',
                subject: '',
                isCertified: '0', // 默认否
                isSigned: '0'     // 默认否
            },
            // 错误信息存储
            errors: {},
            // 下拉选项数据（保持原有）
            educationOptions: [
                { value: '高中', text: '高中' },
                { value: '大专', text: '大专' },
                { value: '本科', text: '本科' },
                { value: '硕士', text: '硕士' },
                { value: '博士', text: '博士' }
            ],
            subjectOptions: [
                { value: '计算机科学', text: '计算机科学' },
                { value: '英语', text: '英语' },
                { value: '数学', text: '数学' },
                { value: '物理', text: '物理' },
                { value: '化学', text: '化学' }
            ]
        }
    },
    methods: {
        // 清除单个字段的错误提示
        clearError(field) {
            if (this.errors[field]) {
                this.$set(this.errors, field, '');
            }
        },

        // 表单验证逻辑（替代 uni-forms）
        validateForm() {
            const errors = {};
            const { name, education, company, city, phone, subject } = this.formData;

            // 姓名验证
            if (!name.trim()) {
                errors.name = '请输入姓名';
            }

            // 学历验证
            if (!education) {
                errors.education = '请选择学历';
            }

            // 单位验证
            if (!company.trim()) {
                errors.company = '请输入工作单位';
            }

            // 城市验证
            if (!city.trim()) {
                errors.city = '请输入所在城市';
            }

            // // 手机号验证
            // if (!phone.trim()) {
            //     errors.phone = '请输入联系电话';+-
            // } else if (!/^1[3-9]\d{9}$/.test(phone.trim())) {
            //     errors.phone = '请输入正确的手机号码';
            // }

            // 报考科目验证
            if (!subject) {
                errors.subject = '请选择报考科目';
            }

            this.errors = errors;
            // 无错误返回 true，有错误返回 false
            return Object.keys(errors).length === 0;
        },

        // 提交表单
        submitForm() {
            const isValid = this.validateForm();

            if (isValid) {
                console.log('表单数据:', this.formData);
                // 提交成功提示（Vue2 通用弹窗）
                firstApi.saveUser(this.formData).then(res => {
                    console.log(res);
                    if (res.code === 1) {
                        alert('提交成功！');
                    }

                }).catch(err => {
                    console.log(err);
                    alert('提交失败！');
                });

                // 可选：重置表单
                // this.resetForm();
            } else {
                console.log('表单验证失败:', this.errors);
                // 验证失败提示
                alert('请完善表单信息！');

                // 可选：滚动到第一个错误字段
                this.scrollToFirstError();
            }
        },

        // 重置表单（可选）
        resetForm() {
            this.formData = {
                name: '',
                education: '',
                company: '',
                city: '',
                phone: '',
                subject: '',
                isCertified: '0',
                isSigned: '0'
            };
            this.errors = {};
        },

        // 滚动到第一个错误字段（优化体验）
        scrollToFirstError() {
            const firstErrorKey = Object.keys(this.errors)[0];
            if (firstErrorKey) {
                const errorElement = document.querySelector(`.form-item-${firstErrorKey}`);
                if (errorElement) {
                    errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }
        }
    }
}
</script>

<style scoped>
/* 容器样式 */
.form-container {
    padding: 20px;
    background-color: #f5f5f5;
    min-height: 100vh;
    box-sizing: border-box;
}

/* 标题样式 */
.form-title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    margin: 20px 0;
    color: #333;
}

/* 表单内容容器 */
.form-content {
    background-color: #fff;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* 表单项容器 */
.form-item {
    margin-bottom: 25px;
    position: relative;
    /* 为每个字段添加唯一类名，用于滚动定位 */
}

.form-item-name {
    margin-bottom: 25px;
}

.form-item-education {
    margin-bottom: 25px;
}

.form-item-company {
    margin-bottom: 25px;
}

.form-item-city {
    margin-bottom: 25px;
}

.form-item-phone {
    margin-bottom: 25px;
}

.form-item-subject {
    margin-bottom: 25px;
}

/* 标签样式 */
.form-label {
    display: block;
    font-size: 16px;
    color: #333;
    margin-bottom: 8px;
    font-weight: 500;
}

/* 输入框样式 */
.form-input {
    width: 100%;
    height: 44px;
    line-height: 44px;
    padding: 0 12px;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    font-size: 16px;
    color: #333;
    box-sizing: border-box;
    outline: none;
}

.form-input:focus {
    border-color: #42b983;
    /* Vue 主题色 */
    box-shadow: 0 0 0 2px rgba(66, 185, 131, 0.2);
}

/* 下拉选择框样式 */
.form-select {
    width: 100%;
    height: 44px;
    line-height: 44px;
    padding: 0 12px;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    font-size: 16px;
    color: #333;
    box-sizing: border-box;
    outline: none;
    background-color: #fff;
    appearance: none;
    /* 清除原生下拉箭头 */
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 16px;
}

.form-select:focus {
    border-color: #42b983;
    box-shadow: 0 0 0 2px rgba(66, 185, 131, 0.2);
}

/* 单选组样式 */
.radio-group {
    display: flex;
    align-items: center;
    gap: 30px;
    margin-top: 8px;
}

.radio-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    color: #333;
    cursor: pointer;
}

.radio-label input[type="radio"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

/* 错误提示样式 */
.error-message {
    position: absolute;
    bottom: -20px;
    left: 0;
    font-size: 14px;
    color: #f56c6c;
    /* 错误色 */
    white-space: nowrap;
}

/* 提交按钮样式 */
.submit-btn {
    width: 100%;
    height: 48px;
    line-height: 48px;
    background-color: #42b983;
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s;
    margin-top: 20px;
}

.submit-btn:hover {
    background-color: #359469;
}

.submit-btn:active {
    background-color: #2d7d56;
}
</style>